<template>
  <div id="about">
    <div class="content project middle">
      <div class="cell">
        <div class="container">
          <p class="sub-title text-center">About Us</p>
        </div>
      </div>
    </div>
  
  </div>
</template>

<script>
// import axios from "axios";
export default {
  name: 'about'
}


</script>

<style>
</style>
